/* add_os_plan.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.85 20.16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M525.66.19h0A10.07,10.07,0,0,0,517,5.09a2.89,2.89,0,0,1,1.18-.21,3.41,3.41,0,0,1,1.05-.1h.32a2.91,2.91,0,0,1,2.31.94,2.73,2.73,0,0,1,.52,1l3.52-4.21,5.6,6.7h-3.3v3.6h3.2l-5.6,6-4-4.28-.11.57a2.92,2.92,0,0,1-3.13,2.38,10.08,10.08,0,0,0,17.14-7.14v-.06A10.05,10.05,0,0,0,525.66.19Z" transform="translate(-513.84 -0.19)" />
            <path class="foreground-gl" d="M522.45,10.89v.33c-.11.55-.33.66-1,.66H519l-.44,2.86c-.11.55-.33.77-1,.77h-.33c-.55,0-.77-.22-.66-.77l.44-2.86h-2.42c-.66,0-.88-.11-.77-.66v-.33c.11-.55.33-.77,1-.77h2.42l.44-2.64c.11-.66.44-.77,1-.77H519c.55,0,.77.11.66.77l-.44,2.64h2.42C522.45,10.12,522.56,10.23,522.45,10.89Z" transform="translate(-513.84 -0.19)" />
        </svg>
    `
};
